import { Inject, Injectable } from '@angular/core';
import { IConfig } from '../interfaces/config.interface';


@Injectable({
    providedIn: 'root'
  })
export class HeapIoService {
    isDeepLink: boolean;
    isBuyNow: boolean;
    version: string;
    source: string;
    isStandalone: boolean;
    isLegacyCreditApp: boolean;
    isModalPrequal: boolean;
    canRetry: boolean = true;

  constructor(    @Inject('config') public config: IConfig,){
    this.isDeepLink = !!this.config?.Sitecore?.PreQualLeadInfo?._isDeepLink;
    this.isBuyNow = this.config?.Sitecore?.isBuyNow;

    this.source = this.getSource();
    this.isStandalone = this.config?.Sitecore?.IsStandAlonePreQual;
    // conflicting flags, standalone and modal...
    this.isModalPrequal = !this.config?.Sitecore?.IsContactStore && this.config?.Sitecore?.IsPrequalification && !!this.config?.Sitecore?.apiDomain;

  }

  public trackSubmit(data) {

    if(typeof(data) === 'string') {
      if(this.isBuyNow && data.indexOf('Backend returned code 0')>=0 ){
          //TBD: what to track here
      }
      return;    
    }
    else if(!data || !data.IsSuccess || !data.Data){
        this.trackFormSubmissionFailure();
        return;
    }
    else {
        let properties: any = {};
        let prequalAmt = 0;
        let prequalified: boolean =  false;     
        if(data.Data) {
            prequalified = data.Data?.prequalified || data.Data?.PreQualifiedResponse?.Success;
        
            if(data.Data?.prequalified){
              prequalAmt = data?.Data?.amount || 0;
            }
            else if(data.Data?.PreQualifiedResponse?.PreQualifiedInformation) {
              prequalAmt = data.Data.PreQualifiedResponse.PreQualifiedInformation.PreQualifiedAmount || 0;
            }        
        }

        if(prequalified && prequalAmt > 0) {
            properties.preQualResponse = 'APPROVED';
        }
        else {
            properties.preQualResponse ='NEED MORE INFO';
        }
        this.trackPageview('pre-qualification/form-success', properties);  

    }
  }

  public trackPageview(pageName?: string, properties?: any) {
    const heap = (window as any).heap;
    if(!heap &&  this.canRetry){
      this.canRetry = false;
      setTimeout(() => {
        this.trackPageview(pageName, properties);
      }, 300);
    }
    if (heap?.trackPageview) {
      //scenario of closing modal instance
      if (pageName === 'close') {
        heap.track('close modal for Pre-qualification');
        heap.trackPageview({ close: true });
        console.log('heap.io trackPageview (close)');
        return;
      }

      let preQualVersion = '1';

      const pageviewProperties = {
        url: this.getUrlProperty(pageName),
        properties:{
            action:'Pre-Qual - Form Load',
            isDeepLink: this.isDeepLink,
            isHybrid: this.isBuyNow,
            isBuyNow: this.isBuyNow,
            'preQual-Version': preQualVersion,
            source: this.getSource(),
            isStandalone: this.isStandalone,
        }

      };
      if(properties) {
        pageviewProperties.properties = { ...pageviewProperties.properties, ...properties };
      }

      heap.trackPageview(pageviewProperties);
      console.log('heap.io trackPageview ', pageviewProperties);

    }
  }

  public track(event: string, data: any) {
    const heap = (window as any).heap;
    if (heap?.track) {
      heap.track(event, data);
    }
  }

  private trackFormSubmissionFailure() {
    this.trackPageview('pre-qualification/form-failure');
  }
  private getUrlProperty(pageName:string){

    let path = this.getPathname();  
    if(this.getSource() === 'VDP' ) {
      path = '/cars';
    }
    path = `${path}/${pageName || ''}`;

    path = path.replace(/\/\//g, '/');

    let prefix = this.getEnvironment().replace(/\/$/, '');      

    const query = this.getQueryString(); 

    return `${prefix}${path}${query}`;    
  };

  private getEnvironment() {
    return (window as any)?.top?.location?.origin;
  }
  private getPathname() {
    return (window as any)?.top?.location?.pathname;
  }

  private getQueryString() {
    return (window as any)?.top?.location?.search;
  }

  private getSource(){
  let source = '';

  try {
    const location = (window as any)?.top?.location;
    const pathname = location?.pathname || '';
    if((location?.origin || '').indexOf('autonation')>= 0 ){
      if(pathname === '/'){
        source = 'HOME';
      }
      else  if(pathname.toLowerCase().indexOf('/cars/') === 0) {
        source = 'VDP';   
      }       
      else if(pathname.toLowerCase().indexOf('/cars-for-sale') === 0 || pathname.indexOf('/new-cars') === 0 || pathname.indexOf('/used-cars') === 0){
        source = 'SRP';       
      } 
      else if(pathname.toLowerCase().indexOf('/pre-qualification') === 0 ){
        source = 'PREQUAL';
      }  
      else if(pathname.toLowerCase().indexOf('/buy-now/') === 0 ){
        source = 'BUYNOW';
      } 
      else if(pathname.toLowerCase().indexOf('/my-account/') === 0 ){
        source = 'MYACCOUNT';
      }  
      else if (pathname.toLowerCase().indexOf('/buy-now') === 0) {
        source = 'BUYNoW';
      }       
      
     }
     else {
        source = 'T3';   
     }
  } catch (err) {
    console.warn('Cross-origin access blocked → setting source=T3');
    source = 'T3';
  }

  return source;
}


}